import { AuthService } from './../services/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { User } from './../interfaces/user'

@Component({
selector: 'app-login',
templateUrl: './login.component.html',
styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	fieldTextType: boolean;
	repeatFieldTextType: boolean;

	@BlockUI() blockUI: NgBlockUI;

	email: string = "";
	pass: string = "";
	jwt: any;
	user: User = {
		id_user: "",
		appKey: "",
		id_role: "",
		role: "",
		id_organization: "",
		id_org_internal: "",
		iat: 0,
		exp: 0,
	};

	constructor(
		private toastrService: ToastrService,
		private authService: AuthService,
		private router: Router
	) { }

	ngOnInit(): void {
	}

	verifyLogin(): void{
		this.blockUI.start('Loading');

		const data = {
		email: this.email,
		pass: this.pass,
		appKey: "RMM"
		}

		this.authService.verifyLogin(data).subscribe(
			(res) => {
				if (res.success) {
					this.jwt = res.data.jwt;
					
					if (res.data.isActive){
						this.authService.signIn(this.jwt);
						// decode jwt -> id_user -> save last connect -> redirect pages
						this.authService.decodeJWT(this.jwt).subscribe(
							(res: any) => {
								if (res.success){
									const idClient = res.data.id_user;

									this.authService.logConnection(idClient).subscribe(
										(res) => {
										if (res.success){
											this.blockUI.stop();
										}
										else{
											this.blockUI.stop();
										}
										},
										(error) => {
											this.blockUI.stop();
										}
									);
								} else{
									if (res.errorSet.includes('InvalidRequest')) {
										this.toastrService.error('Les paramètres sont invalides');
									} else if (res.errorSet.includes('TokenError')) {
										this.toastrService.error(`Token incorrect`);
									}
								}
							},
							(error) => {
								this.blockUI.stop();
								// console.error(error);
								this.toastrService.error('Une erreur s\'est produite');
							}
						);
						this.router.navigate(['/bo/mon-compte']);
					}
					else{
						this.toastrService.error('Compte désactivé');
						this.blockUI.stop();
					}
					this.blockUI.stop();
				} else {
					this.blockUI.stop();
					if (res.errorSet.includes('INVALID_PARAMS') | res.errorSet.includes('INVALID_REQUEST')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('EMAIL_NOT_EXIST')) {
						this.toastrService.error(`Votre email et/ou mot de passe sont incorrects`);
					} if (res.errorSet.includes("INCORRECT_PASSWORD")) {
						this.toastrService.error(`Votre email et/ou mot de passe sont incorrects`);
					} else if (res.errorSet.includes('ERROR_SERVER') | res.errorSet.includes('SERVER_ERROR')) {
						this.toastrService.error('Une erreur de serveur');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}

	// switching methode show password
	toggleFieldTextType() {
		this.fieldTextType = !this.fieldTextType;
	  }
	
	  toggleRepeatFieldTextType() {
		this.repeatFieldTextType = !this.repeatFieldTextType;
	  }
}
